import { Alert, Box, Card, Grid, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useSelector } from '../../../../redux/store';
import { ChevronBox } from '../../../../reusable-components/chevron-box';
import IconBadge from '../../admin/facility/ReviewWorkflow/IconBadge';
import { fDateTime } from '../../../../utils/formatTime';
import OrderReviewerTooltipText from './OrderReviewerTooltipText';

OrderReviewers.propTypes = {
  pending: PropTypes.bool
}

export default function OrderReviewers({ pending = false }) {
  const { id = '' } = useParams();
  const { orderById, } = useSelector((state) => state.orders || {});
  const { requiredReviewPreference, orderReviews, department } = orderById[id] || {};

  return (
    <>
      {orderReviews?.length > 0 && (
        <Box sx={{ minWidth: '300px', width: '100%', mb: 2 }}>
          <Card sx={{ p: 1, width: '100%' }}>

            {pending && (
              (requiredReviewPreference === "Any" && orderReviews?.some((r) => r.required) &&
                !orderReviews?.some((r) => r.required && r.reviewed))
              || requiredReviewPreference !== "Any" && orderReviews?.some((r) => r.required && !r.reviewed)
            )
              && (
                <Alert sx={{ mb: 1, fontSize: 11 }} severity="warning">
                  {requiredReviewPreference === "Any" ? `Order is waiting on a required reviewer` : `Order is waiting on all required reviewers`}
                </Alert>
              )}
            <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={0}>
              <Grid item>
                <Typography variant="body2" sx={{ fontWeight: 'bold' }} color="info.main">
                  Reviewers:
                </Typography>
              </Grid>
              <Grid item>
                <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={0}>
                  {orderReviews?.length > 0 &&
                    orderReviews.map((reviewer, reviewerIndex) => {
                      const { reviewerName, reviewerEmail, reviewed, reviewedDate } = reviewer;
                      const firstName = reviewerName?.split(' ')[0];
                      const colors = ['#208ee0', '#f19e3b', '#b128bc', '#8dc63f'];
                      const countConditions = +!!reviewer.required + +!!reviewer.minimum
                        + +!!reviewer.budget + +!!reviewer.agoraCategories?.length;
                      return (
                        <Box key={reviewerIndex} sx={{ position: "relative", display: "inline-block" }}>
                          <ChevronBox
                            color={colors[reviewerIndex % colors.length]}
                            reviewed={reviewed}
                            reviewerIndex={reviewerIndex}
                            length={orderReviews.length}
                            children={<Tooltip title={
                              reviewed ? `${reviewerName} - ${reviewerEmail} reviewed on ${fDateTime(reviewedDate)}`
                                : pending ? `Awaiting review from ${reviewerName} - ${reviewerEmail}`
                                  : `${reviewerName} - ${reviewerEmail} did not review`
                            }>
                              <Typography>{firstName}</Typography>
                            </Tooltip>
                            }
                          />
                          <Box sx={{ position: "absolute", top: -12, right: 0, display: "flex", gap: "2px" }}>
                            {countConditions > 0
                              && <IconBadge size="sm" title={
                                <OrderReviewerTooltipText reviewer={reviewer} department={department} />}
                                color="info" text={countConditions?.toString()} />}
                          </Box>
                        </Box>
                      );
                    })}
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Box >
      )
      }
    </>
  );
}
